import CryptoJS from 'crypto-js';
import { getKeyHash } from './getKeyHash';
export function encrypt(messageToencrypt) {
    if (messageToencrypt === null || messageToencrypt === '')
        return messageToencrypt;
    const ls = localStorage.getItem('tenantEncryptionKeys');
    if (!ls || ls === '')
        return messageToencrypt;
    const lsObj = JSON.parse(ls);
    const ek = lsObj.encryptionKey;
    if (!ek || ek === '')
        return messageToencrypt;
    const encryptedMessage = CryptoJS.AES.encrypt(messageToencrypt, ek);
    const keyhash = getKeyHash(ek);
    return 'SonarEncrypted' + keyhash + String(encryptedMessage);
}
